import { get } from 'lodash';

// Mirrors Rails I18n interpolation: pass a `replacements` object and any `%{key}`
// placeholder in the translated string gets swapped for the matching value.
//   fetchTranslation('we_need_to_verify_email', { email: 'a@b.c' })
//   // -> "We need to verify a@b.c belongs to you..."
export const fetchTranslation = (key, replacements = null) => {
  let translation = get(window.translations, key);
  if (!translation) {
    return `[Missing Translation]: ${key}`;
  }

  if (replacements) {
    translation = applyReplacements(translation, replacements);
  }

  return translation;
};

function applyReplacements(translation, replacements) {
  return Object.entries(replacements).reduce((acc, [name, value]) => (
    acc.replace(new RegExp(`%\\{${name}\\}`, 'g'), value)
  ), translation);
}
